import { render, staticRenderFns } from "./BiographiesVisual.vue?vue&type=template&id=40d9a4ae&scoped=true"
import script from "./BiographiesVisual.vue?vue&type=script&lang=js"
export * from "./BiographiesVisual.vue?vue&type=script&lang=js"
import style0 from "./BiographiesVisual.vue?vue&type=style&index=0&id=40d9a4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d9a4ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
